import { defineComponent as _defineComponent } from 'vue'
import { Accordion } from '@/modules/common/components/Accordion';
import { ButtonIconContextual, NavBar, Link, BaseText } from '@warrenbrasil/nebraska-web';
import type { IProductAdditionalInfo } from '@/modules/catalog/services/products/products-types';
import type { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductAdditionalInfo',
  props: {
  additionalInfo: {
    type: Object as PropType<IProductAdditionalInfo>,
    required: true
  }
},
  emits: ['close-additional-info'],
  setup(__props, { emit }) {

const props = __props;





return { __sfc: true,props, emit, Accordion, ButtonIconContextual, NavBar, Link, BaseText }
}

})